import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Mapping for toast types to styles
const typeStyles = {
  success: {
    emoji: "✅",
    gradient: "from-green-400 via-emerald-500 to-green-400",
  },
  error: {
    emoji: "❌",
    gradient: "from-red-500 via-pink-500 to-red-500",
  },
  info: {
    emoji: "ℹ️",
    gradient: "from-blue-400 via-indigo-500 to-blue-400",
  },
  warn: {
    emoji: "⚠️",
    gradient: "from-yellow-400 via-orange-400 to-yellow-400",
  },
};

const CustomToast = ({ title, message, type = "info" }) => {
  const style = typeStyles[type] || typeStyles.info;

  return (
    <div className="w-full max-w-full bg-[#111827] text-white px-5 py-4 rounded-lg shadow-xl border border-white/10 relative overflow-hidden">
      {/* Dynamic glow ring */}
      <div
        className={`absolute -inset-1 z-0 rounded-lg bg-gradient-to-r ${style.gradient} blur-md opacity-40 animate-pulse`}
      />

      {/* Content */}
      <div className="relative z-10 flex items-start gap-3">
        <div className="text-2xl">{style.emoji}</div>
        <div>
          <div className="font-semibold text-sm">{title}</div>
          <div className="text-sm">{message}</div>
        </div>
      </div>
    </div>
  );
};

export const ToastifyProvider = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar
      closeOnClick
      pauseOnHover
      draggable
      limit={3}
      closeButton={false}
      toastClassName={() =>
        "bg-transparent shadow-none p-0 m-0 w-full max-w-md"
      }
      bodyClassName={() => "p-0 m-0"}
      theme="light"
    />
  );
};

// Toast Trigger Helpers
export const notifyCustom = ({ type = "info", title, message }) => {
  toast(<CustomToast type={type} title={title} message={message} />, {
    icon: false,
  });
};

export const notifySuccess = (msg) =>
  notifyCustom({ type: "success", title: "Success", message: msg });

export const notifyError = (msg) =>
  notifyCustom({ type: "error", title: "Error", message: msg });

export const notifyInfo = (msg) =>
  notifyCustom({ type: "info", title: "Info", message: msg });

export const notifyWarn = (msg) =>
  notifyCustom({ type: "warn", title: "Warning", message: msg });
